import { api } from './orpc-client'
import { UserRestrictionsData } from '../types/userRestrictions'

/**
 * Fetch user restrictions from the backend
 * Returns restriction status and configuration for the current user
 */
export async function getUserRestrictions(): Promise<UserRestrictionsData> {
  return await api.wallet.user.restrictions({}) as UserRestrictionsData
}
